export default "__VITE_ASSET__i0CPAR7l__"